import {
  StockTransferSubtype,
  WarehouseOutwardModel,
} from "../model/warehouse_outward_model";
import RegularSTView from "./outward_view/RegularSTView";
import ReplacementSTView from "./outward_view/ReplacementSTView";
import ReturnableSTView from "./outward_view/ReturnableSTView";
import FoCSTView from "./outward_view/FoCSTView";
import ReturnableDCView from "./outward_view/ReturnableDCView";
import SalesOrderView from "./outward_view/SalesOrderView";

type Props = {
  open: boolean;
  onClose: () => void;
  outward?: WarehouseOutwardModel;
};

const OutwardViewModal = ({ open, onClose, outward }: Props) => {
  if (!open || !outward) return null;

  if (outward.type === "SO") {
    return <SalesOrderView open={open} onClose={onClose} outward={outward} />;
  }

  if (
    outward.type === "ST" &&
    outward.st_subtype === StockTransferSubtype.REGULAR
  ) {
    return <RegularSTView open={open} onClose={onClose} outward={outward} />;
  }
  if (
    outward.type === "ST" &&
    outward.st_subtype === StockTransferSubtype.RETURNABLE
  ) {
    return <ReturnableSTView open={open} onClose={onClose} outward={outward} />;
  }
  if (
    outward.type === "ST" &&
    outward.st_subtype === StockTransferSubtype.FOC
  ) {
    return <FoCSTView open={open} onClose={onClose} outward={outward} />;
  }
  if (
    outward.type === "ST" &&
    outward.st_subtype === StockTransferSubtype.REPLACEMENT
  ) {
    return (
      <ReplacementSTView open={open} onClose={onClose} outward={outward} />
    );
  }
  if (
    outward.type === "ST" &&
    outward.st_subtype === StockTransferSubtype.REVERSE_DC
  ) {
    return <ReturnableDCView open={open} onClose={onClose} outward={outward} />;
  }

  return null;
};

export default OutwardViewModal;
